import React, { Component } from 'react';
import '../../css/styles.css'
import logocombank from '../../images/combank-logo.png'; 

class HeaderComponent extends Component {
    render() {
        return (
            <>

            <div className="logo">
                <img src={logocombank} className="img-main" alt="Commercial Bank Sri Lanka" title="Commercial Bank Sri Lanka"/>
            </div>
            </>

        );
    }
}


export default HeaderComponent